import * as React from 'react';

import ReservationCustomerCategoryQuantityOverrideItem from "./reservationCustomerCategoryQuantityOverrideItem";
import { CustomerCategory } from "../../../store/pages/customerCategories/types";
import { CustomerCategoryQuantityOverride } from "./reservationDetails";
import * as PropTypes from "prop-types";
import {ITranslationContext} from "../../../translations";

interface CustomerQuantityOverridePanelProps {
    customerCategories: CustomerCategory[];
    reservationCustomerCategoryQuantityOverrides: CustomerCategoryQuantityOverride[];
    reservationCustomerCategoryMaxOverallQuantityChanged: (customerCategoryId: string, val: number) => void;
}

const ReservationCustomerCategoryQuantityOverridePanel = (props: CustomerQuantityOverridePanelProps, context: ITranslationContext) => {
    const { t } = context;
    const { reservationCustomerCategoryQuantityOverrides } = props;
    return <>
        <label>{t('ReservationCustomerCategoryQuantityOverridePanel:title')}</label>
        <table className='table table-condensed no-border' style={{ marginBottom: '0' }}>
            <tbody>
                {reservationCustomerCategoryQuantityOverrides?.map(rccqo => {
                    return <ReservationCustomerCategoryQuantityOverrideItem
                        key={`${rccqo.customerCategoryId}_reservationcustomercategoryquantityoverrideitem`}
                        reservationCustomerCategoryQuantityOverrideItem={rccqo}
                        overrideMaxOverallQuantity={rccqo!.maxOverallQuantity}
                        maxOverallQuantityChanged={props.reservationCustomerCategoryMaxOverallQuantityChanged}
                    />
                })}
            </tbody>
        </table>
    </>
};

ReservationCustomerCategoryQuantityOverridePanel.contextTypes = {
    t: PropTypes.func
}

export default ReservationCustomerCategoryQuantityOverridePanel;
